var _link, _style, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfTexas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 720,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    id: "dark-mode",
    rel: "stylesheet",
    href: ""
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bf0d3e",
    d: "M0 0h1080v720H0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1080v360H0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00205b",
    d: "M0 0h360v720H0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(180,360)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M0,-135v135h67.5",
    transform: "rotate(18 0,-135)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "scale(-1,1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(288)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfTexas);
export default __webpack_public_path__ + "static/media/Flag_of_Texas.a0cd7cb59ee6eb5de90b7799cb698d75.svg";
export { ForwardRef as ReactComponent };